import React from "react";
import { Link } from "react-router-dom";
import logo from "./../../logo.png";

const Footer = () => {
  return (
    <footer className="bg-[#f4f4f4] mt-[75px] font-sans">

      {/* Main Footer Content */}
      <div className="w-[80%] mx-auto py-8
                      grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-10">

        {/* Logo + Social */}
        <div className="mt-2">
          <Link to="/">
            <img className="w-50 h-10 mb-3" src={logo} alt="happenhood" />
          </Link>

          <div className="flex gap-3 text-[18px]">
            <a href="#"><i className="fab fa-facebook text-blue-600"></i></a>
            <a href="#"><i className="fab fa-instagram text-pink-500"></i></a>
            <a href="#"><i className="fab fa-twitter text-sky-500"></i></a>
            <a href="#"><i className="fab fa-youtube text-red-600"></i></a>
          </div>
        </div>

        {/* Quick Links */}
        <div className="mt-2">
          <h4 className="mb-3 text-[16px] font-bold border-b border-gray-300 pb-1 text-justify">
            Quick Links
          </h4>

          <ul className="space-y-2 text-justify">
            <li><Link className="hover:underline text-gray-800" to="/">Home</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/about-us">About Us</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/contact-us">Contact Us</Link></li>
          </ul>
        </div>

        {/* Categories */}
        <div className="mt-2">
          <h4 className="mb-3 text-[16px] font-bold border-b border-gray-300 pb-1 text-justify">
            Categories
          </h4>

          <ul className="grid grid-cols-2 gap-y-2 text-justify">
            <li><Link className="hover:underline text-gray-800" to="/dance">Dance</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/comedy">Comedy</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/music">Music</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/conference">Conference</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/devotional">Devotional</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/plays">Plays</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/sports">Sports</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/seminar">Seminar</Link></li>
          </ul>
        </div>

        {/* Policies */}
        <div className="mt-2">
          <h4 className="mb-3 text-[16px] font-bold border-b border-gray-300 pb-1 text-justify">
            Our Policies
          </h4>

          <ul className="space-y-2 text-justify">
            <li><Link className="hover:underline text-gray-800" to="/guide">Guide</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/terms">Terms & Condition</Link></li>
            <li><Link className="hover:underline text-gray-800" to="/privacy">Privacy Policy</Link></li>
          </ul>
        </div>

      </div>

      {/* Bottom Bar */}
      <div className="bg-black text-white text-center py-2 text-[12px]">
        © {new Date().getFullYear()} Happenhood. All Rights Reserved
      </div>

    </footer>
  );
};

export default Footer;